import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

//get user list

export const List_User_API = `${LOCAL_URL}/admin/user/listUsers`
export const BLOCK_USER = `${LOCAL_URL}/admin/user/blockUser`
export const UNBLOCK_USER = `${LOCAL_URL}/admin/user/unBlockUser`
export const SEARCH_USER = `${LOCAL_URL}/admin/user/listUsersSearch`
export const GET_PLAN = `${LOCAL_URL}/admin/subscription/listSubscriptionPlan`
export const CREATE_PLAN = `${LOCAL_URL}/admin/subscription/createSubscriptionUser`
export const CREATE_USER = `${LOCAL_URL}/admin/user/createUser`

const headers = {
  Authorization: API_TOKEN,
  //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
}

// function to get all user
export async function list_User(page: number) {
  return await axios.post(List_User_API, {page})
}

// function to create user
export async function create_user(
  email_id: string,
  contact_number: string,
  accouont_holder_name: string
) {
  return await axios.post(CREATE_USER, {email_id, contact_number, accouont_holder_name})
}

// axios request to block user
export async function BlockUser(obj: string) {
  let data = {
    account_uuid: obj,
  }
  return await axios.post(BLOCK_USER, data, {
    headers,
  })
}

// axios requewst to unblock user
export async function UnblockUser(obj: string) {
  let data = {
    account_uuid: obj,
  }
  return await axios.post(UNBLOCK_USER, data, {
    headers,
  })
}

// user common search
export async function SearchUsers(obj: string) {
  let data = {
    query: obj,
  }
  return await axios.post(SEARCH_USER, data, {
    headers,
  })
}

// api to get subscription plans
export async function getSubscriptionPlans() {
  return await axios.get(GET_PLAN, {
    headers,
  })
}

// function to give subscription plan to user
export async function createSubscriptionPlan(account_uuid: string, subscription_id: number) {
  return await axios.post(
    CREATE_PLAN,
    {account_uuid, subscription_id},
    {
      headers,
    }
  )
}
